export var SELECT_DAY = 'SELECT_DAY';
export var selectDay = function selectDay(selectedDay) {
  return {
    type: SELECT_DAY,
    selectedDay: selectedDay
  };
};